import * as utility from "../services"
import * as common_components from "../editor_common_components"
import * as react_components from "../reactcomponent"
import { Innosoft_InnoBI_Controllers_ApiBuilderController as ApibuilderController } from "../generated_api/generated_api"
import { DropDownList } from "../components/drop_down_list"
import { registerComponents } from "../statistic_ui"
import { Menu } from "../../core/components/menu"
import { Grid } from "../../core/components/grid"
import { General } from "../../../siteManagement/general"
import { DialogHelper } from "../../core/util/dialogHelper"
import { Helper } from "../../core/util/helper"
import React from "react"
import {RightDrawerContainer} from "../../core/components/rightDrawerContainer";
import {Entity} from "../../core/components/commonApp";
export { registerComponents };

export class ApiBuilderList extends React.Component<any, any> {
    private gridOptions;
    constructor(props) {
        super(props);
        this.state = {}
        this.gridOptions = this.createGridOptions();
        General.Sheet.Manager.getTopMostSheet().setTitle(Helper.getTranslation("WebSMS.Statistics.ApiEditor"));
    }

    componentDidMount() {
        new ApibuilderController().GetAllServices((result) => {
            this.setState({ services: result });
        });
    }

    handleAddNewOrEdit = (serviceId, serviceName, typeId) => {
        this.setState({ serviceIdValue: serviceId, serviceNameValue: serviceName, typeValue: typeId, formState: "createNewOrEdit" });
    }

    handleDelete = async (serviceId) => {
        const shouldDelete = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"))
        if (!shouldDelete) {
            return;
        }
        var selectedItem = this.state.selectedItem;
        if (selectedItem) {
            this.setState({ formState: "default" });
            var that = this;

            new ApibuilderController().DeleteService(selectedItem.Id, (result) => {
                var services = that.state.services.slice();
                for (var i = 0; i < services.length; i++) {
                    if (services[i].Id == selectedItem.Id) {
                        services.splice(i, 1);
                        that.setState({ services: services });
                        break;
                    }
                }
            });

        }
    }

    handleClose = () => {
        this.setState({ formState: "default" });
    }

    handleSave = () => {
        this.setState({ formState: "default" });
        var that = this;

        new ApibuilderController().CreateNewOrEditService({ Id: this.state.serviceIdValue, ServiceName: this.state.serviceNameValue, Type: this.state.typeValue }, (result) => {
            var services = that.state.services.slice();
            if (that.state.serviceIdValue == 0) {
                services.push(result);
            } else {
                for (var i = 0; i < services.length; i++) {
                    if (services[i].Id == result.Id) {
                        services[i] = result;
                        break;
                    }
                }
            }
            that.setState({ services: services });
        });
    }

    handleTypeChange = (type) => {
        this.setState({ typeValue: type });
    }

    handleServiceNameChange = (serviceName) => {
        this.setState({ serviceNameValue: serviceName });
    }

    editRow = () => {
        var selectedItem = this.state.selectedItem;
        if (selectedItem) {
            this.handleAddNewOrEdit(selectedItem.Id, selectedItem.ServiceName, selectedItem.Type);
        }
    }

    copy = () => {
        new ApibuilderController().CopyService({ id: this.state.selectedItem.Id }, (result) => {
            var services = this.state.services.slice();
            services.push(result);
            this.setState({ services: services });
        });
    }

    handleSelectedItemChanged = (item) => {
        this.setState({ selectedItem: item });
    }

    handleFleexportClick = (item) => {
        window.location.href = "api/flexcelexport/" + this.state.selectedItem.Id + "/GetExportFile";
    }

    openNewStatisticSheet = (params, e) => {
        e.preventDefault();
        const sheet = General.Sheet.Manager.createSheetWithUrl(`Statistic/apiBuilderDetail?id=${params.Id}`);
    }

    createLink = (params) => {
        return <a href={`apiBuilderDetail?id=${params.Id}`} onClick={this.openNewStatisticSheet.bind(this, params)}>{params.ServiceName}</a >;
    }

    createGridOptions = (): kendo.ui.GridOptions => {
        const gridOptions: any = {
            filterable: true,
            selectable: true,
            columns: [{
                field: "ServiceName", title: "Name",
                reactTemplate: this.createLink,
                filterable: {
                    cell: {
                        operator: "contains",
                        template: function (args) {
                            args.element.css("width", "90%").addClass("k-textbox").keydown(function (e) {
                                setTimeout(function () {
                                    $(e.target).trigger("change");
                                });
                            });
                        },
                        showOperators: false
                    }
                }
            },
            { field: "TypeName", title: "Type", filterable: false },
            {
                field: "IsInternal", width: "150px", title: "Is internal", template: '#if(IsInternal){#<h4 style="text-align: center; color: transparent; text-shadow: 0 0 0 red">&\\#10071;<\h4>#}#'
            }
            ]
        };
        return gridOptions;
    }
    private _renderRightDrawerComponent = () => {


        const entity: Entity = {
            IsNew: true,
            RecordRight: {
                CanRead: true, CanWrite: true
            },
            IsWatchable: false,
            IsWatched: false
        };
        return (<RightDrawerContainer
            moduleName={""}
            appName={""}
            visible={true}
            width={400}
            entity={entity}
            renderAlways={true}
            multipleComponents={[{
                moduleName: "app/core/components/iframe",
                iconName: "question-circle",
                renderAlways: true,
                props: {
                    url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/48118c06-a269-496a-9779-73a26b30244e.html"
                }
            }]}
        />);
    }
    render() {
        if (this.state.formState == "createNewOrEdit") {
            var dialog = <NewOrEditServiceDialog onClose={this.handleClose} onSave={this.handleSave} onTypeChange={this.handleTypeChange} onServiceNameChange={this.handleServiceNameChange} serviceIdValue={this.state.serviceIdValue} serviceNameValue={this.state.serviceNameValue} typeValue={this.state.typeValue} />
        }
        return (
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                {dialog}
                {this._renderRightDrawerComponent()}
                <Menu entries={[
                    { text: "New", onClick: this.handleAddNewOrEdit.bind(this, 0, "", "") },
                    { text: "Delete", onClick: this.handleDelete, show: this.state.selectedItem ? true : false },
                    { text: "Edit head data", onClick: this.editRow, show: this.state.selectedItem ? true : false },
                    { text: "Copy", onClick: this.copy, show: this.state.selectedItem ? true : false }
                ]} onSelect={() => { }} enableMenuItem={() => true} handleEval={() => { }} />

                {this.state.services ? <Grid id="API_BUILDER_LIST" data={this.state.services} options={this.gridOptions} onSelectionChanged={this.handleSelectedItemChanged} /> : null}
            </div>);
    }
};

class NewOrEditServiceDialog extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = { types: [{ Id: 0, Name: "SQL" }, { Id: 1, Name: "Hierarchical SQL" }, { Id: 2, Name: "C# Assembly" }] };
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = () => {
        this.props.onSave();
    }

    handleTypeChange = (typeValue) => {
        this.props.onTypeChange(typeValue);
    }

    handleServiceNameChange = (serviceNameValue) => {
        this.props.onServiceNameChange(serviceNameValue);
    }

    render() {
        const title = (this.props.serviceIdValue != '') ? "Edit service" : "Add new service";
        const typePicker = (this.props.serviceIdValue == '') ? <DropDownList label="Type" value={this.props.typeValue} data={this.state.types} valueField="Name" keyField="Id" onChange={this.handleTypeChange} /> : null
        return <react_components.BasicDialog title={title} onClose={this.handleClose} onSave={this.handleSave}>
            <react_components.KendoMaskedTextBox label="Name" name="service_name" value={this.props.serviceNameValue} onTextChange={this.handleServiceNameChange} />
            {typePicker}
        </react_components.BasicDialog>;
    }
};